import { LicenseInfo } from "@mui/x-license-pro";

/**
 * Registers the MUI X Pro licence, which the app does once at its root and
 * Storybook does for every story that draws a Pro component (the stats date
 * range picker), or they render with a "Missing license key" watermark.
 */
export function registerMuiLicense() {
  LicenseInfo.setLicenseKey(
    "ef1845bb653a1232a0e7d2bb051819f3Tz0xMjM3ODgsRT0xNzk5MDIwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
  );
}
